import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaptchaComponent } from './components/captcha/captcha.component';
import { RecaptchaModule, RecaptchaSettings, RECAPTCHA_SETTINGS } from 'ng-recaptcha';
import { environment } from '@environment';

@NgModule({
  imports: [
    CommonModule,
    RecaptchaModule
  ],
  declarations: [
    CaptchaComponent
  ],
  providers: [
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey: environment.gcaptcha } as RecaptchaSettings,
    }
  ],
  exports: [
    CaptchaComponent
  ]
})
export class CaptchaModule { }
